// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__395ak","actions":"GroupTable_actions__9Amkh","deleteModalFooter":"GroupTable_deleteModalFooter__1xbXn"};